import {Component, OnDestroy, OnInit} from '@angular/core';
import {TranslateService} from '@atumverse/core-decorators';
import {FinfraStudioPageTopBreadcrumbService} from '../../services/finfra-studio-page-top-breadcrumb.service';

@Component({
  selector: 'finfra-page-top-breadcrumb-widget',
  templateUrl: './page-top-breadcrumb-widget.component.html',
})
export class FinfraPageTopBreadcrumbWidgetComponent implements OnInit, OnDestroy {
  public translateLabelsName = 'finfra-page-top-breadcrumb';
  public translateFolder = 'labels/app-core-components/';
  public translateLabelsLoaded = false;


  constructor(
    private translateService: TranslateService,
    public finfraStudioPageTopBreadcrumbService: FinfraStudioPageTopBreadcrumbService
  ) {

  }

  ngOnInit(): void {
    this.translateService.loadLabels(this);
  }

  ngOnDestroy(): void {

  }
}

